export default __webpack_public_path__ + "static/taylor-4101b5b7f467d4f76fd6fc92a0674d08.jpg";